import React from 'react';
import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import SValidityCheckListItem from 'Components/structural/SValidityCheckListItem/SValidityCheckListItem';

import styles from './OverviewValidation.style';
import { CampaignFormValues } from '../../saveCampaign.hook';

export const OverviewValidation = () => {
  const { watch } = useFormContext<CampaignFormValues>();

  const validInformation = watch('name') && watch('description');

  const validRandomScheduling = (watch('contents') && watch('contents')!.length > 0) || false;
  const manualSchedulingContainsEmptySession =
    watch('orderedSessions') && watch('orderedSessions')!.some((item) => item.length === 0);

  const validManualScheduling =
    !manualSchedulingContainsEmptySession && watch('orderedSessions') && watch('orderedSessions')!.length > 0;
  const validScheduling = validRandomScheduling || validManualScheduling;

  const validAudience =
    watch('audiences.magicCode') || watch('audiences.emailList') || watch('audiences.segmentations');

  return (
    <div>
      <div style={styles.title}>{t('activities:overview.title')}</div>
      <div style={styles.comment}>{t('activities:overview.description')}</div>
      <div style={styles.listItem}>
        <SValidityCheckListItem
          title={t('activities:overview.campaign_validity_title')}
          description={t('activities:overview.campaign_validity_label')}
          isActive={validInformation}
        />
      </div>
      <div style={styles.listItem}>
        <SValidityCheckListItem
          title={t('activities:overview.scheduling_validity_title')}
          description={t('activities:overview.scheduling_validity_label')}
          isActive={validScheduling}
        />
      </div>

      <div style={styles.listItem}>
        <SValidityCheckListItem
          title={t('activities:overview.audience_validity_title')}
          description={t('activities:overview.audience_validity_label')}
          isActive={validAudience}
        />
      </div>
    </div>
  );
};
